import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import s from './Comment.css';

export default function CommentPresentation({ name, profileImageWebp, profileImageJpg, jobTitle, commentText }) {
  useStyles(s);
  return (
    <div className={s.commentContainer}>
      <div className={s.commentHeader}>
        <picture>
          <source srcSet={profileImageWebp} type="image/webp" />
          <source srcSet={profileImageJpg} type="image/jpg" />
          <img src={profileImageJpg} alt="profile" loading="lazy" className={s.profileImage} width="64px" height="64px" />
        </picture>
        <div>
          <div className={s.name}>{name}</div>
          <div className={s.jobTitle}>{jobTitle}</div>
        </div>
      </div>
      <p className={s.description}>{commentText}</p>
    </div>
  );
}

CommentPresentation.propTypes = {
  name: PropTypes.string.isRequired,
  profileImageWebp: PropTypes.object.isRequired,
  profileImageJpg: PropTypes.object.isRequired,
  jobTitle: PropTypes.string.isRequired,
  commentText: PropTypes.string.isRequired,
};
